import HoverInfo from './HoverInfo'

export default HoverInfo
